
const digest = '4173a251c3c5899254bdcf66ffb136fb23e84280f68f2fd0387ae037972dd883';
const classes = {"wrapper":"_wrapper_iku4i_1","available":"_available_iku4i_7","warning":"_warning_iku4i_22","button":"_button_iku4i_27"};
const css = `._wrapper_iku4i_1 {
  font-family: Rubik, "sans-serif";
  display: flex;
  flex-direction: column;
  gap: 20px;
}
._wrapper_iku4i_1 ._available_iku4i_7 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  background: #ecfdf5;
  padding: 14px 20px;
  border-radius: 25px;
  border: 1px solid rgba(209, 250, 229, 0.5019607843);
  color: #047857;
}
._wrapper_iku4i_1 ._available_iku4i_7 img {
  height: 25px;
}
._wrapper_iku4i_1 ._warning_iku4i_22 {
  color: #dc2929;
  font-weight: 600;
  font-size: 14px;
}
._wrapper_iku4i_1 ._button_iku4i_27 {
  width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  